function mounterCbsData(item) {
  const classification = item.classificationTribute;
  const baseCbs = item.value_subtotal_product || 0;
  const aliquotCbs = (item.aliquot_ibs_cbs && item.aliquot_ibs_cbs.aliquot_cbs) || 0;
  
  // Se não há classificação tributária, retorna valores sem redução
  if (!classification) {
    console.warn('Classification tribute not found for item:', item.product_id);
    return {
      taxable_base_cbs: baseCbs,
      aliquot_cbs_original: aliquotCbs,
      aliquot_cbs: aliquotCbs,
      value_cbs: parseFloat(((baseCbs * aliquotCbs) / 100).toFixed(2)),
      unit_trib_select_cbs: "",
      tax_base_select_cbs: baseCbs,
      _quant_base_trib_sele: item.amount || 0,
      aliquot_imp_select_cbs: 0,
      value_tax_select_cbs: item.value_tax_selective_prod || 0,
      value_tribute_operation: parseFloat(((baseCbs * aliquotCbs) / 100).toFixed(2)),
      pRedCBS: 0
    };
  }
  
  const pRedCBS = classification.p_red_cbs ? parseFloat(classification.p_red_cbs) : 0;
  const finalAliquotCbs = classification && pRedCBS > 0
    ? aliquotCbs * (1 - (pRedCBS / 100))
    : aliquotCbs;
  
  // Cálculo da base reduzida CBS: valor * (100 - redução) / 100
  const taxBaseSelectCbs = pRedCBS > 0 
    ? parseFloat((baseCbs * (100 - pRedCBS) / 100).toFixed(2))
    : baseCbs;
  
  const finalValueCbs = (baseCbs * finalAliquotCbs) / 100;

  return {
    taxable_base_cbs: baseCbs,
    aliquot_cbs_original: aliquotCbs,  // Alíquota original CBS
    aliquot_cbs: parseFloat(finalAliquotCbs.toFixed(4)),  // Alíquota efetiva CBS (após redução)
    value_cbs: parseFloat(finalValueCbs.toFixed(2)),
    unit_trib_select_cbs: "",
    tax_base_select_cbs: taxBaseSelectCbs,  // Base reduzida CBS
    _quant_base_trib_sele: item.amount || 0,
    aliquot_imp_select_cbs: 0,
    value_tax_select_cbs: item.value_tax_selective_prod || 0,
    value_tribute_operation: parseFloat(finalValueCbs.toFixed(2)),
    pRedCBS: pRedCBS  // Incluir percentual de redução CBS
  };
}

/**
 * @param {Object} item - Item da venda com dados tributários
 * @returns {Object} Dados calculados do IBS (UF e Municipal)
 */
function mounterIbsData(item) {
  const classification = item.classificationTribute;
  const baseValue = item.value_subtotal_product || 0;
  const aliquotIbsUf = (item.aliquot_ibs_cbs && item.aliquot_ibs_cbs.aliquot_ibs_uf) || 0;
  const aliquotIbsMun = (item.aliquot_ibs_cbs && item.aliquot_ibs_cbs.aliquot_ibs_mun) || 0;
  
  // Se não há classificação tributária, retorna valores sem redução
  if (!classification) {
    console.warn('Classification tribute not found for item:', item.product_id);
    return {
      aliquot_ibs_uf_original: aliquotIbsUf,
      aliquot_ibs_uf: aliquotIbsUf,
      tax_base_ibs_uf: baseValue,
      value_tribute_ibs_uf: parseFloat(((baseValue * aliquotIbsUf) / 100).toFixed(2)),
      value_tribute_operation_ibs_uf: item.value_total_tax_uf_prod || 0,
      aliquot_ibs_mun_original: aliquotIbsMun,
      aliquot_ibs_mun: aliquotIbsMun,
      tax_base_ibs_mun: baseValue,
      value_tribute_ibs_mun: parseFloat(((baseValue * aliquotIbsMun) / 100).toFixed(2)),
      value_tribute_operation_ibs_mun: item.value_total_tax_mun_prod || 0,
      pRedIBS: 0
    };
  }
  
  const pRedIBS = classification.p_red_ibs ? parseFloat(classification.p_red_ibs) : 0;
  
  // Aplicar redução nas alíquotas
  const finalAliquotIbsUf = classification && pRedIBS > 0
    ? aliquotIbsUf * (1 - (pRedIBS / 100))
    : aliquotIbsUf;
    
  const finalAliquotIbsMun = classification && pRedIBS > 0
    ? aliquotIbsMun * (1 - (pRedIBS / 100))
    : aliquotIbsMun;
  
  // Cálculo da base reduzida IBS: valor * (100 - redução) / 100
  const taxBaseIbsUf = pRedIBS > 0 
    ? parseFloat((baseValue * (100 - pRedIBS) / 100).toFixed(2))
    : baseValue;
    
  const taxBaseIbsMun = pRedIBS > 0 
    ? parseFloat((baseValue * (100 - pRedIBS) / 100).toFixed(2))
    : baseValue;
  
  const valueIbsUf = (baseValue * finalAliquotIbsUf) / 100;
  const valueIbsMun = (baseValue * finalAliquotIbsMun) / 100;
  
  return {
    aliquot_ibs_uf_original: aliquotIbsUf,  // Alíquota original IBS UF
    aliquot_ibs_uf: parseFloat(finalAliquotIbsUf.toFixed(4)),  // Alíquota efetiva IBS UF (após redução)
    tax_base_ibs_uf: taxBaseIbsUf,  // Base reduzida IBS UF
    value_tribute_ibs_uf: parseFloat(valueIbsUf.toFixed(2)),
    value_tribute_operation_ibs_uf: item.value_total_tax_uf_prod || 0,
    aliquot_ibs_mun_original: aliquotIbsMun,  // Alíquota original IBS Municipal
    aliquot_ibs_mun: parseFloat(finalAliquotIbsMun.toFixed(4)),  // Alíquota efetiva IBS Municipal (após redução)
    tax_base_ibs_mun: taxBaseIbsMun,  // Base reduzida IBS Municipal
    value_tribute_ibs_mun: parseFloat(valueIbsMun.toFixed(2)),
    value_tribute_operation_ibs_mun: item.value_total_tax_mun_prod || 0,
    pRedIBS: pRedIBS // Percentual de redução IBS da classificação tributária
  };
}

function getIbsCbsIndicators(classification, cstIbsCbs) {
  if (!classification) {
    return {
      ind_gIBSCBS: "0",
      ind_gIBSCBSMono: "0",
      ind_gRed: "0",
      ind_gDif: "0",
      ind_gTransfCred: "0",
      ind_gCredPresIBSZFM: "0",
      ind_gAjusteCompet: "0",
      ind_gTribRegular: "0",
      ind_gCredPresOper: "0",
      ind_gMonoPadrao: "0", 
      indMonoReten: "0",
      indMonoRet: "0",
      indMonoDif: "0"
    };
  }
  
  return {
    ind_gIBSCBS: cstIbsCbs.ind_gIBSCBS? "1" : "0",
    ind_gIBSCBSMono: cstIbsCbs.ind_gIBSCBSMono? "1" : "0",
    ind_gRed: cstIbsCbs.ind_gRed? "1" : "0",
    ind_gDif: cstIbsCbs.ind_gDif? "1" : "0",
    ind_gTransfCred: cstIbsCbs.ind_gTransfCred? "1" : "0",
    ind_gCredPresIBSZFM: cstIbsCbs.ind_gCredPresIBSZFM? "1" : "0",
    ind_gAjusteCompet: cstIbsCbs.ind_gAjusteCompet? "1" : "0",
    ind_gTribRegular: classification.ind_g_trib_regular ? "1" : "0",
    ind_gCredPresOper: classification.ind_g_cred_pres_oper ? "1" : "0",
    ind_gMonoPadrao: classification.ind_g_mono_padrao ? "1" : "0",
    indMonoReten: classification.ind_mono_reten ? "1" : "0",
    indMonoRet: classification.ind_mono_ret ? "1" : "0",
    indMonoDif: classification.ind_mono_dif ? "1" : "0"
  };
}

/**
 * @param {number} aliquotaOriginal - Alíquota original
 * @param {number} percentualReducao - Percentual de redução (0-100)
 * @returns {number} Alíquota após redução
 */
function calculateReducedAliquot(aliquotaOriginal, percentualReducao) {
  if (!percentualReducao || percentualReducao <= 0) {
    return aliquotaOriginal;
  }
  
  return aliquotaOriginal * (1 - (percentualReducao / 100));
}

/**
 * @param {number} valorBase - Valor base original
 * @param {number} percentualReducao - Percentual de redução (0-100)
 * @returns {number} Base reduzida
 */
function calculateReducedBase(valorBase, percentualReducao) {
  if (!percentualReducao || percentualReducao <= 0) {
    return valorBase;
  }
  
  return parseFloat((valorBase * (100 - percentualReducao) / 100).toFixed(2));
}

module.exports = {
  mounterCbsData,
  mounterIbsData,
  getIbsCbsIndicators,
  calculateReducedAliquot,
  calculateReducedBase
};